import React, { Suspense } from "react";

import { Navigate, createBrowserRouter } from "react-router-dom";

import { PublicRoute } from "./PublicRoute";
import { PrivateRoute } from "./PrivateRoute";
import { childRoutes } from "./routes";

import App from "../App";

import AuthLayout from "../layout/AuthLayout";
import DashboardLayout from "../layout/DashboardLayout";

import NotFound from "../pages/NotFound";
import PublicLayout from "../layout/PublicLayout";
import LoadingSpinner from "../Icons/LoadingSpinner";

const Login = React.lazy(() => import("../pages/auth/token/sign-in"));
const Otp = React.lazy(() => import("../pages/auth/token/otp"));

const HotListCandidate = React.lazy(() => import("../pages/candidate-hot-list/profile"));
const CandidateHotList = React.lazy(() => import('../pages/Dashboard/jobs/hot-list/public-list'));


const loadingSpinner = (
  <LoadingSpinner className="mr-2 h-full w-14 animate-spin" />
);

export const router = createBrowserRouter([
  {
    path: "/login",
    element: (
      <PublicRoute>
        <AuthLayout>
          <Login />
        </AuthLayout>
      </PublicRoute>
    ),
  },
  {
    path: "/login/otp",
    element: (
      <PublicRoute>
        <AuthLayout>
          <Otp />
        </AuthLayout>
      </PublicRoute>
    ),
  },
  {
    path: "/hot-list-candiate/profile/:id",
    element: (
      <PublicRoute>
        <PublicLayout >
        <Suspense fallback={loadingSpinner}>
          <HotListCandidate />
          </Suspense>
        </PublicLayout>
      </PublicRoute>
    ),
  },
  {
    path: "/hot-list-candiate/list/:id",
    element: (
      <PublicRoute>
        <PublicLayout >
        <Suspense fallback={loadingSpinner}>
          <CandidateHotList />
          </Suspense>
        </PublicLayout>
      </PublicRoute>
    ),
  },
  {
    path: "/",
    element: <Navigate to="/login" />, // Redirect to /login
  },
  {
    path: "/",
    element: (
      <PrivateRoute>
        <DashboardLayout>
          <App />
        </DashboardLayout>
      </PrivateRoute>
    ),
    children: childRoutes,
  },
  
  {
    path: "*",
    element: <NotFound />,
  },
]);
